import React from 'react'
import SearchPicker from '../common/SearchPicker'

const SupplierPicker = (props) => {

    const { state } = props

    const option = (x) => <span>{`${x.code}, ${x.name}, ${x.currency}`}</span>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.code}, ${state?.name}, ${state.currency}` : ""}
            option={(x) => option(x)}
        />
    )
}

export default SupplierPicker